/*! 1.6.4 */
!function () {
  function a(a) {
    if (!a.__listeners) {
      a.upload || (a.upload = {}), a.__listeners = [];
      var b = a.upload.addEventListener;

      a.upload.addEventListener = function (c, d) {
        a.__listeners[c] = d, b && b.apply(this, arguments);
      };
    }
  }

  var b = function b() {
    try {
      var a = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
      if (a) return !0;
    } catch (b) {
      if (void 0 != navigator.mimeTypes["application/x-shockwave-flash"]) return !0;
    }

    return !1;
  },
      c = function c(a, b) {
    window.XMLHttpRequest.prototype[a] = b(window.XMLHttpRequest.prototype[a]);
  };

  if (window.XMLHttpRequest && (!window.FormData || window.FileAPI && FileAPI.forceLoad ? (c("open", function (b) {
    return function (c, d, e) {
      a(this), this.__url = d;

      try {
        b.apply(this, [c, d, e]);
      } catch (f) {
        f.message.indexOf("Access is denied") > -1 && b.apply(this, [c, "_fix_for_ie_crossdomain__", e]);
      }
    };
  }), c("getResponseHeader", function (a) {
    return function (b) {
      return this.__fileApiXHR ? this.__fileApiXHR.getResponseHeader(b) : a.apply(this, [b]);
    };
  }), c("getAllResponseHeaders", function (a) {
    return function () {
      return this.__fileApiXHR ? this.__fileApiXHR.abort() : null == a ? null : a.apply(this);
    };
  }), c("abort", function (a) {
    return function () {
      return this.__fileApiXHR ? this.__fileApiXHR.abort() : null == a ? null : a.apply(this);
    };
  }), c("setRequestHeader", function (b) {
    return function (c, d) {
      if ("__setXHR_" === c) {
        a(this);
        var e = d(this);
        e instanceof Function && e(this);
      } else this.__requestHeaders = this.__requestHeaders || {}, this.__requestHeaders[c] = d, b.apply(this, arguments);
    };
  }), c("send", function (a) {
    return function () {
      var c = this;

      if (arguments[0] && arguments[0].__isShim) {
        var d = arguments[0],
            e = {
          url: c.__url,
          complete: function complete(a, b) {
            !a && c.__listeners.load && c.__listeners.load({
              type: "load",
              loaded: c.__loaded,
              total: c.__total,
              target: c,
              lengthComputable: !0
            }), !a && c.__listeners.loadend && c.__listeners.loadend({
              type: "loadend",
              loaded: c.__loaded,
              total: c.__total,
              target: c,
              lengthComputable: !0
            }), "abort" === a && c.__listeners.abort && c.__listeners.abort({
              type: "abort",
              loaded: c.__loaded,
              total: c.__total,
              target: c,
              lengthComputable: !0
            }), void 0 !== b.status && Object.defineProperty(c, "status", {
              get: function get() {
                return b.status;
              }
            }), void 0 !== b.statusText && Object.defineProperty(c, "statusText", {
              get: function get() {
                return b.statusText;
              }
            }), Object.defineProperty(c, "readyState", {
              get: function get() {
                return 4;
              }
            }), void 0 !== b.response && Object.defineProperty(c, "response", {
              get: function get() {
                return b.response;
              }
            }), Object.defineProperty(c, "responseText", {
              get: function get() {
                return b.responseText;
              }
            }), Object.defineProperty(c, "response", {
              get: function get() {
                return b.responseText;
              }
            }), c.__fileApiXHR = b, c.onreadystatechange && c.onreadystatechange();
          },
          fileprogress: function fileprogress(a) {
            a.target = c, c.__listeners.progress && c.__listeners.progress(a), c.__total = a.total, c.__loaded = a.loaded;
          },
          headers: c.__requestHeaders
        };
        e.data = {}, e.files = {};

        for (var f = 0; f < d.data.length; f++) {
          var g = d.data[f];
          null != g.val && null != g.val.name && null != g.val.size && null != g.val.type ? e.files[g.key] = g.val : e.data[g.key] = g.val;
        }

        setTimeout(function () {
          if (!b()) throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
          c.__fileApiXHR = FileAPI.upload(e);
        }, 1);
      } else a.apply(c, arguments);
    };
  })) : c("setRequestHeader", function (a) {
    return function (b, c) {
      if ("__setXHR_" === b) {
        var d = c(this);
        d instanceof Function && d(this);
      } else a.apply(this, arguments);
    };
  }), window.XMLHttpRequest.__isShim = !0), !window.FormData || window.FileAPI && FileAPI.forceLoad) {
    var d = function d(a) {
      if (!b()) throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
      var c = angular.element(a);
      if (!c.hasClass("js-fileapi-wrapper") && (null != a.getAttribute("ng-file-select") || null != a.getAttribute("data-ng-file-select"))) if (FileAPI.wrapInsideDiv) {
        var d = document.createElement("div");
        d.innerHTML = '<div class="js-fileapi-wrapper" style="position:relative; overflow:hidden"></div>', d = d.firstChild;
        var e = a.parentNode;
        e.insertBefore(d, a), e.removeChild(a), d.appendChild(a);
      } else c.addClass("js-fileapi-wrapper");
    },
        e = function e(a) {
      return function (b) {
        for (var c = FileAPI.getFiles(b), d = 0; d < c.length; d++) {
          void 0 === c[d].size && (c[d].size = 0), void 0 === c[d].name && (c[d].name = "file"), void 0 === c[d].type && (c[d].type = "undefined");
        }

        b.target || (b.target = {}), b.target.files = c, b.target.files != c && (b.__files_ = c), (b.__files_ || b.target.files).item = function (a) {
          return (b.__files_ || b.target.files)[a] || null;
        }, a && a.apply(this, [b]);
      };
    },
        f = function f(a, b) {
      return ("change" === b.toLowerCase() || "onchange" === b.toLowerCase()) && "file" == a.getAttribute("type");
    };

    HTMLInputElement.prototype.addEventListener && (HTMLInputElement.prototype.addEventListener = function (a) {
      return function (b, c, g, h) {
        f(this, b) ? (d(this), a.apply(this, [b, e(c), g, h])) : a.apply(this, [b, c, g, h]);
      };
    }(HTMLInputElement.prototype.addEventListener)), HTMLInputElement.prototype.attachEvent && (HTMLInputElement.prototype.attachEvent = function (a) {
      return function (b, c) {
        f(this, b) ? (d(this), window.jQuery ? angular.element(this).bind("change", e(null)) : a.apply(this, [b, e(c)])) : a.apply(this, [b, c]);
      };
    }(HTMLInputElement.prototype.attachEvent)), window.FormData = FormData = function FormData() {
      return {
        append: function append(a, b, c) {
          this.data.push({
            key: a,
            val: b,
            name: c
          });
        },
        data: [],
        __isShim: !0
      };
    }, function () {
      if (window.FileAPI || (window.FileAPI = {}), FileAPI.forceLoad && (FileAPI.html5 = !1), !FileAPI.upload) {
        var a,
            c,
            d,
            e,
            f,
            g = document.createElement("script"),
            h = document.getElementsByTagName("script");
        if (window.FileAPI.jsUrl) a = window.FileAPI.jsUrl;else if (window.FileAPI.jsPath) c = window.FileAPI.jsPath;else for (d = 0; d < h.length; d++) {
          if (f = h[d].src, e = f.indexOf("angular-file-upload-shim.js"), -1 == e && (e = f.indexOf("angular-file-upload-shim.min.js")), e > -1) {
            c = f.substring(0, e);
            break;
          }
        }
        null == FileAPI.staticPath && (FileAPI.staticPath = c), g.setAttribute("src", a || c + "FileAPI.min.js"), document.getElementsByTagName("head")[0].appendChild(g), FileAPI.hasFlash = b();
      }
    }();
  }

  window.FileReader || (window.FileReader = function () {
    function a(a, c) {
      var d = {
        type: a,
        target: b,
        loaded: c.loaded,
        total: c.total,
        error: c.error
      };
      return null != c.result && (d.target.result = c.result), d;
    }

    var b = this,
        c = !1;
    this.listeners = {}, this.addEventListener = function (a, c) {
      b.listeners[a] = b.listeners[a] || [], b.listeners[a].push(c);
    }, this.removeEventListener = function (a, c) {
      b.listeners[a] && b.listeners[a].splice(b.listeners[a].indexOf(c), 1);
    }, this.dispatchEvent = function (a) {
      var c = b.listeners[a.type];
      if (c) for (var d = 0; d < c.length; d++) {
        c[d].call(b, a);
      }
    }, this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;

    var d = function d(_d) {
      if (c || (c = !0, b.onloadstart && this.onloadstart(a("loadstart", _d))), "load" === _d.type) {
        b.onloadend && b.onloadend(a("loadend", _d));
        var e = a("load", _d);
        b.onload && b.onload(e), b.dispatchEvent(e);
      } else if ("progress" === _d.type) {
        var e = a("progress", _d);
        b.onprogress && b.onprogress(e), b.dispatchEvent(e);
      } else {
        var e = a("error", _d);
        b.onerror && b.onerror(e), b.dispatchEvent(e);
      }
    };

    this.readAsArrayBuffer = function (a) {
      FileAPI.readAsBinaryString(a, d);
    }, this.readAsBinaryString = function (a) {
      FileAPI.readAsBinaryString(a, d);
    }, this.readAsDataURL = function (a) {
      FileAPI.readAsDataURL(a, d);
    }, this.readAsText = function (a) {
      FileAPI.readAsText(a, d);
    };
  });
}();